'use strict';

import React from 'react';
import { connect } from 'react-redux';

import { format } from 'date-fns';
import cn from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors, appOperations } from '@/state/domains/app';
import { assignmentsSelectors, assignmentsOperations } from '@/state/domains/assignments';

import Link from '@/views/common/Link';

import s from './styles.scss';

const sx = cn.bind(s);

export default connect(
	(state, props) => ({
		pageId: appSelectors.getPageId(state, props),
		weekNav: appSelectors.getWeekNav(state, props),
		dayNav: appSelectors.getDayNav(state, props),
		prevDay: assignmentsSelectors.getPrevDay(state, props),
		location: appSelectors.getLocation(state, props),
	}),
	{
	}
)(
	({ pageId, username, date, weekNav, dayNav, prevDay, location }) => {

		const currD = new Date(date + ' 00:00:00');

		let goDate = '';
		let url = '';
		let prevD;
		let prevTitle;

		switch (pageId) {

			case 'user-weekly':

				goDate = date in weekNav ? weekNav[ date ].prev : null;

				if (goDate) {
					prevD = new Date(goDate + ' 00:00:00');
					prevTitle = format(prevD, 'EEE MMM do');
					url = `/user/${ username }/${ goDate }`;
				}
				break;

			case 'daily-route':

				goDate = date in dayNav ? dayNav[ date ].prev : null;

				if (goDate) {
					prevD = new Date(goDate + ' 00:00:00');
					prevTitle = format(prevD, 'EEE MMM do');
					url = `/user/${ username }/${ goDate }/route`;
				}
				break;
		}

		if (!goDate) {
			return (
				<div className={ sx('disabled') }>
					<FontAwesomeIcon icon='chevron-left' color='#444' />
				</div>
			);
		}

		const locObj = { pathname: url };

		if (location.state) {
			locObj.state = location.state;
		}

		return (
			<Link to={ locObj } className={ s.link }>
				<FontAwesomeIcon icon='chevron-left' color='#444' />
			</Link>
		);
	}
);
